function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeIconButtonStyles = function makeIconButtonStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  var makeGetButtonStyles = function makeGetButtonStyles(_ref2) {
    var size = _ref2.size;
    // Overriding size tokens because we are reusing button tokens but the
    // vertical padding is slightly different
    var sizeOverrides = size === "dense" ? {
      paddingBottom: "5px",
      paddingTop: "5px"
    } : {
      paddingBottom: "7px",
      paddingTop: "7px"
    };
    return function (_ref3) {
      var fullWidth = _ref3.fullWidth,
        variant = _ref3.variant;
      var button = tokens.button;
      var widthOverrides = fullWidth ? {
        width: "100%"
      } : {
        minWidth: "auto",
        paddingLeft: primitives.spacings[3],
        paddingRight: primitives.spacings[3]
      };
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, button[variant][size].default), sizeOverrides), widthOverrides), {}, {
        "&:hover": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].hover), sizeOverrides), widthOverrides),
        "&.Mui-disabled": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].disabled), sizeOverrides), widthOverrides),
        "&:focus": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].focus), sizeOverrides), widthOverrides),
        "&:focus:active": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].pressed), sizeOverrides), widthOverrides),
        "&:active": _objectSpread(_objectSpread(_objectSpread({}, button[variant][size].pressed), sizeOverrides), widthOverrides)
      });
    };
  };
  var getSmallButtonStyles = makeGetButtonStyles({
    size: "dense"
  });
  var getMediumButtonStyles = makeGetButtonStyles({
    size: "defaultSize"
  });
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: primitives.borderRadii.medium,
          "& [class*='MuiSvgIcon-root']": {
            color: "inherit"
          },
          "&[class*='MuiIconButton-sizeSmall']": {
            "& [class*='MuiSvgIcon-root']": {
              fontSize: "20px"
            },
            "&.DhigIconButton--variant--contained": getSmallButtonStyles({
              variant: "contained"
            }),
            "&.DhigIconButton--variant--contained.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "contained"
            }),
            "&.DhigIconButton--variant--outlined": getSmallButtonStyles({
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--outlined.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--text": getSmallButtonStyles({
              variant: "text"
            }),
            "&.DhigIconButton--variant--text.DhigIconButton--fullWidth": getSmallButtonStyles({
              fullWidth: true,
              variant: "text"
            })
          },
          "&[class*='MuiIconButton-sizeMedium']": {
            "& [class*='MuiSvgIcon-root']": {
              fontSize: "24px"
            },
            "&.DhigIconButton--variant--contained": getMediumButtonStyles({
              variant: "contained"
            }),
            "&.DhigIconButton--variant--contained.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "contained"
            }),
            "&.DhigIconButton--variant--outlined": getMediumButtonStyles({
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--outlined.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "outlined"
            }),
            "&.DhigIconButton--variant--text": getMediumButtonStyles({
              variant: "text"
            }),
            "&.DhigIconButton--variant--text.DhigIconButton--fullWidth": getMediumButtonStyles({
              fullWidth: true,
              variant: "text"
            })
          }
        }
      }
    }
  };
};